"use client"
import React from 'react'
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';
import Loader from './Loader';

const WingsRangeandunits = () => {
     const {
        theme,
        toggleTheme,
        toggleHighlightLinks,
        highlightLinks,
        language,
        toggleLanguage,
      } = useTheme();
    //  const [page, setPage] = useState(1);
    const { data: list, loading, error } = useFetch(
        "/website/wings-ranges-and-units",
        []
    );

    return (
        <>
            <div className='row'>
                <div className='col'>
                    <div className='directorate-main'>
                        <h4>{language=="en"?"RANGE OFFICES":"റേഞ്ച് ഓഫീസുകൾ"}</h4>
                        <p>{language=="en"?"There are four Ranges, each headed by a Superintendent of Police with territorial jurisdiction, located at Thiruvananthapuram, Kottayam, Ernakulam and Kozhikkode. Each Range comprises of following revenue districts.":"തിരുവനന്തപുരം, കോട്ടയം, എറണാകുളം, കോഴിക്കോട് എന്നിവിടങ്ങളിലായി പ്രാദേശിക അധികാരപരിധിയുള്ള പോലീസ് സൂപ്രണ്ടിന്റെ നേതൃത്വത്തിൽ നാല് റേഞ്ചുകളുണ്ട്. ഓരോ റേഞ്ചിലും താഴെപ്പറയുന്ന റവന്യൂ ജില്ലകൾ ഉൾപ്പെടുന്നു."}</p>
                    </div>
                </div>
            </div>
            {loading?(
                <>
                <Loader n={24} f={0.3} />
                </>
            ):<>
                          <div className='row g-3 g-lg-4 mt-1'>
                {list?.length > 0 ? (
                    <>
                        {list?.map((item, index) => (
                            <>
                                <div key={index} className='col-md-6'>
                                    <div className='mision-card h-100'>
                                        <h4>{item?.name}</h4>
                                        <div className='ph-email'>
                                            <p> <IoCall style={{ color: "#ff9500" }} />{item?.phone}</p>
                                            <a style={{ color: "#ccc" }} href={`mailto:${item?.email}`} className='mx-0 mx-lg-3'> <MdEmail style={{ color: "#ff9500" }} /> {item?.email}</a>
                                        </div>
                                        <p className='mt-2'>{item.details}</p>
                                        <ul>
                                            {item?.units?.map((item, index) => (
                                                <>
                                                    <li key={index}>{item}</li>
                                                </>
                                            ))}

                                        </ul>
                                    </div>
                                </div>

                            </>
                        ))}


                    </>
                ) : <>
                    <h4>No data found</h4>
                </>}



            </div>

            </>}
            

        </>


    )
}

export default WingsRangeandunits
